<template>
  <BreadCrumb PageTitle="Nouvelle dépense" />
  <NewSpent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewSpent from "../../components/Spents/NewSpent.vue";

export default defineComponent({
  name: "NewSpentPage",
  components: {
    BreadCrumb,
    NewSpent,
  },
}); 
</script>